import { rect, cRect } from '../../../pixel/canvas';
import { SLOT } from '../slots';
import type { Hull } from '../../types';

// Wide shoulders + big head give the stocky silhouette;
// torso/legs match average positions so all tops/bottoms/shoes fit correctly.
export const body_stocky: Hull = {
  id: 'body_stocky',
  name: 'Stocky',
  drawBody: (ctx, p) => {
    // Head (wider: 16px vs average 12px)
    rect(ctx, 24, 8, 16, 12, p.light);
    rect(ctx, 24, 8, 1, 12, p.shadow);
    rect(ctx, 39, 8, 1, 12, p.shadow);
    rect(ctx, 25, 8, 14, 1, p.shadow);
    rect(ctx, 25, 19, 14, 1, p.shadow);
    // Neck (wide: 6px)
    rect(ctx, 29, 20, 6, 2, p.light);
    // Shoulders (very wide: 22px — main stocky marker)
    cRect(ctx, 22, 22, 2, p.light);
    // Arms
    rect(ctx, 23, 24, 4, 12, p.light);
    rect(ctx, 37, 24, 4, 12, p.light);
    // Torso (14px — same as average so shirts fit)
    rect(ctx, 25, 24, 14, 12, p.light);
    rect(ctx, 25, 24, 1, 12, p.shadow);
    rect(ctx, 38, 24, 1, 12, p.shadow);
    // Hips (14px — same as average so pants fit)
    rect(ctx, 25, 36, 14, 3, p.shadow);
    // Left leg (same x as average so pants align)
    rect(ctx, 25, 39, 6, 14, p.light);
    rect(ctx, 25, 39, 1, 14, p.shadow);
    // Right leg
    rect(ctx, 33, 39, 6, 14, p.light);
    rect(ctx, 38, 39, 1, 14, p.shadow);
  },
  mounts: {
    [SLOT.HEAD]:   { anchor: { x: 32, y: 8 } },
    [SLOT.FACE]:   { anchor: { x: 32, y: 13 } },
    [SLOT.HAT]:    { anchor: { x: 32, y: 8 } },
    [SLOT.TORSO]:  { anchor: { x: 32, y: 22 } },
    [SLOT.WAIST]:  { anchor: { x: 32, y: 36 } },
    [SLOT.FOOT_L]: { anchor: { x: 28, y: 53 } },
    [SLOT.FOOT_R]: { anchor: { x: 36, y: 53 } },
  },
};
